import './src/styles/global.css';
import React from 'react';
import SmoothScroll from './src/components/SmoothScroll';
import CustomCursor from './src/components/CustomCursor';

export const wrapPageElement = ({ element }) => (
  <SmoothScroll>
    {element}
    <CustomCursor />
  </SmoothScroll>
);
